import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent, PiStudentBold } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import SubjectRegistrationForm from "../ones/SubjectRegistrationForm";

export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	
	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	async function getData() {
		await callApi("get-student-data", { uuid }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready && data) {
		return (
			<div
				className="container"
			>
				<div className="row">

					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							{data.firstName} {data.middleName} {data.lastName}
							<br/>
							<span className="badge bg-primary">Student</span>
						</h6>
						<hr/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div
							style={{
								width: "150px",
								height: "150px",
								margin: "0 auto",
								borderRadius: "20px",
								overflow: "hidden",
								cursor: "pointer",
								overflow: "hidden",
							}}
							className="bg-surface mShadow1"
						>
							
							{
								(data.passportPic) ?
								<img
									src={CDN_URL + data.passportPic}
									style={{
										width: "100%",
										height: "100%",
									}}
								/>
								:
								<PiStudentBold
									style={{
										width: "100%",
										height: "100%"
									}}
									className="text-muted"
								/>
							}
								
						</div>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">First Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.firstName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Middle Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.middleName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Last Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.lastName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Parent/Guardian First Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.parentFirstName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Parent/Guardian Middle Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.parentMiddleName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Parent/Guardian Last Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.parentLastName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Parent's or Guardian's Phone</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.parentPhone || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Parent's or Guardian's Whatsapp Number</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.parentWhatsapp || "N/A"}
						</h6>
					</div>
					
					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Classrooom</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.classroomName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Stream</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.streamName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 col-6 mt-2 mb-2">
						<label className="form-label">Date of Birth</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.birthDate || "N/A"}
						</h6>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<div className="row">

									<div className="col-md-6 mt-2 mb-2">
										<button
											className="btn btn-rounded btn-outline-dark btn-padded btn-block"
											onClick={() => {
												appContext.navTo({
													item: 'side-view',
													subItem: 'student-payments-profile',
													extraItem: data.uuid,
												})
											}}
										>
											Payments Profile
										</button>
									</div>

									<div className="col-md-6 mt-2 mb-2">
										<button
											className="btn btn-rounded btn-outline-primary btn-padded btn-block"
											onClick={() => {
												appContext.navTo({
													item: 'side-view',
													subItem: 'student-academic-profile',
													extraItem: data.uuid,
												})
											}}
										>
											Academic Profile
										</button>
									</div>

									<div className="col-md-6 mt-2 mb-2">
										<button
											className="btn btn-rounded btn-outline-primary btn-padded btn-block"
											onClick={() => {
												appContext.navTo({
													item: 'side-view',
													subItem: 'student-edit-details',
													extraItem: data.uuid,
												})
											}}
										>
											Edit Details
										</button>
									</div>

								</div>
							</div>
						</div>
					</div>
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}